// import
import AdminDashboard from "views/Dashboard/AdminDashboard.js";
import Tables from "views/Dashboard/Tables.js";
import Profile from "views/Dashboard/Profile.js";
import Customers from "views/Dashboard/Customers.js";
import Personnels from "views/Dashboard/Personnels";
import Account from "views/Dashboard/Account.js";

import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
  HelpIcon,
  SettingsIcon,
} from "components/Icons/Icons";

var dashRoutes = [
  // {
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   rtlName: "لوحة القيادة",
  //   icon: <HomeIcon color="inherit" />,
  //   component: AdminDashboard,
  //   layout: "/users",
  // },
  // {
  //   path: "/inventory",
  //   name: "Inventory",
  //   rtlName: "لوحة القيادة",
  //   icon: <SupportIcon color="inherit" />,
  //   component: Personnels,
  //   layout: "/personnel",
  // },
  {
    path: "/account",
    name: "Account",
    rtlName: "لوحة القيادة",
    icon: <SettingsIcon color="inherit" />,
    secondaryNavbar: true,
    component: Account,
    layout: "/users",
  },
];
export default dashRoutes;
